export class InvalidForm extends Error {
  constructor (name) {
    super(`Form "${name}" is not valid`)
  }
}
